// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"_3BpXe0G","noTitle":"_1Vl10yC _3BpXe0G","asosFocus":"_6DZZlcW","asosLogo":"_3JHHN36","link":"_24SZgSx _6DZZlcW"};